import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { DevicesPayload } from '../../devices/components/devices.models';
import { LOADER_CONTEXT } from 'src/app/services/interceptors/loader.interceptor';
import { RequestProcessingResponse, RetryRequestResponse } from './request-processing.types';

@Injectable({ providedIn: 'root' })
export class RequestProcessingApiService {
  private readonly http = inject(HttpClient);

  getRequests(payload: DevicesPayload): Observable<RequestProcessingResponse> {
    return this.http.post<RequestProcessingResponse>(`/api/twowayrequests`, payload, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }

  cancelRequest(requestId: number): Observable<boolean> {
    return this.http.post<boolean>(`/api/twowayrequests/${encodeURIComponent(requestId)}/cancel`, null);
  }

  retryRequest(requestId: number): Observable<RetryRequestResponse> {
    return this.http.post<RetryRequestResponse>(`/api/twowayrequests/${encodeURIComponent(requestId)}/retry`, null);
  }
}
